import { createStore } from "solid-js/store";
import { components } from "./api";
import { DateTime } from "luxon";

export interface IWeatherMapState {
  sidebarOpen: boolean;
  ct: String;
}

export const WeatherMapState = {
  ct: "Ok",
  sidebarOpen: false,
} as IWeatherMapState;

export const [mapState, setMapState] = createStore({
  sidebarOpen: false,

  // shows only sun/rain/snow/... icons
  onlyDots: false,

  // shows markers without sun info
  withSunSensor: true,

  // shows markers without rain info
  withRainSensor: true,

  currentMapCenter: [0, 0],
  currentMapZoom: 8,

  map: null,
  locations: [],
  markers: [],

  graphForLastXMinutes: 60,

  radarData: {
    loaded: false,
    currentIdx: 0,
    sliderValue: 0.0,
    data: null,
    forceRefresh: false,
    last_step_at: DateTime.now(),
    paused: false,
  },

  overlayOpen: false,
  overlayLoaded: false,
  overlayLocation: undefined,
  overlayData: null,
} as IMapState);

interface IMapState {
  sidebarOpen: boolean;

  // shows only sun/rain/snow/... icons
  onlyDots: boolean;

  // hide icons
  hideDots: boolean;

  // shows markers with sun info
  withSunSensor: boolean;

  // shows markers with rain info
  withRainSensor: boolean;

  // shows markers with images from location
  withImages: boolean;

  // shows rain radar
  rainRadar: boolean;

  radarData: {
    loaded: boolean;
    paused: boolean;
    forceRefresh: boolean;
    sliderValue: number;
    last_step_at: luxon.DateTime;
    currentIdx: number;
    data: components["schemas"]["HttpResponseRadar"];
  };

  graphForLastXMinutes: number;

  locations: Array<components["schemas"]["HttpResponseLocationsItem"]>;

  markers: Array<L.Marker>;
  mapRadarOverlay: L.ImageOverlay | undefined;
  map: L.Map | undefined;
  currentMapCenter: number[];
  currentMapZoom: number;

  overlayOpen: boolean;
  overlayLoaded: boolean;
  overlayLocation: number | undefined;
  // this is when initial load is done
  overlayData: undefined | components["schemas"]["HttpResponseLatestItem"];

  overlayRadarDebug: HTMLCanvasElement | undefined;

  // data when clicked on map, refreshed every time
  overlayDataLatest:
    | undefined
    | components["schemas"]["HttpResponseLatestItem"];
}
